import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import assignmentApis from "../../api/assignmentApis";
import { Assignment } from "../../types/assignmentType";

interface AssignmentState {
  assignments: Assignment[];
  isLoading: boolean;
  page: number;
  size: number;
  total: number;
  filters: Record<string, any>;
}

const initialState: AssignmentState = {
  assignments: [],
  isLoading: false,
  page: 0,
  size: 10,
  total: 0,
  filters: {},
};

export const fetchAssignments = createAsyncThunk(
  "assignment/fetchAssignments",
  async (
    params: {
      branchCode: string;
      page: number;
      size: number;
      filters?: Record<string, any>;
    },
    { rejectWithValue }
  ) => {
    try {
      return await assignmentApis.getAssignments(params);
    } catch {
      return rejectWithValue("Failed to load assignments");
    }
  }
);

const assignmentSlice = createSlice({
  name: "assignment",
  initialState,
  reducers: {
    setFilter(state, action: { payload: { key: string; value: string } }) {
      if (!state.filters) {
        state.filters = {}; // ✅ CRITICAL FIX
      }

      const { key, value } = action.payload;

      if (!value) {
        delete state.filters[key];
      } else {
        state.filters[key] = value;
      }

      state.page = 0;
    },

    clearFilters(state) {
      state.filters = {};
      state.page = 0;
    },

    setPage(state, action) {
      state.page = action.payload;
    },

    setPageSize(state, action) {
      state.size = action.payload;
      state.page = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAssignments.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAssignments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.assignments = action.payload.data.content;
        state.total = action.payload.data.totalElements;
      })
      .addCase(fetchAssignments.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setFilter, clearFilters, setPage, setPageSize } =
  assignmentSlice.actions;
export const assignmentReducer = assignmentSlice.reducer;
